module.exports = __webpack_public_path__ + "static/media/cesga_logo.779719b0.svg";